
import React,{useEffect, useState} from 'react'
import moment from 'moment'
import { Row, Col, Button, Select, message, Spin, Modal, Divider, notification, Icon, Table} from 'antd'
import { sendBatchActionPromise } from '../../promises'
import { sendBdRequestPromise } from '../../promises'
import { useTranslation } from 'react-i18next'
import formTypeValidator from '../../../../helpers/formTypeValidator'
import { getBeneficiariesMatchesPromise } from './promises/getBeneficiariesMatches'

const ModalRequestOpt = ({type, recipients, handleCancel, currentUser, isSendAll, totalCurrentUser, filterCurrentUser}) => {
  const isActiveRecipient = (r) => r && r.status === 'ACTIVE'
  const { t, i18n } = useTranslation('translations')
  const [period, setPeriod] = useState(null)
  const [selectedFormType, setSelectedFormType] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [ cdiRecipients, setCdiRecipients ] = useState(() =>
    (recipients || []).filter(isActiveRecipient)
  )
  const Option = Select;
  const { confirm } = Modal;
  const today = moment().format('DD/MM/YYYY')
  const formatCount = (n) =>
    new Intl.NumberFormat((i18n.language || 'es').replace('_', '-')).format(n)
  const [findUbosMatches, setFindUbosMatches] = useState([]);
  const [isUbosMatchesLoading, setIsUbosMatchesLoading] = useState(true);

  useEffect(() => {
    if (type === 'beneficiariesMatchs'){
      let idsForMatch = []
      cdiRecipients.map(item => 
        idsForMatch.push(item.id)
      )
      getBeneficiariesMatchesPromise(idsForMatch).then(response => {
        setFindUbosMatches(response.data)
        setIsUbosMatchesLoading(false)
      })
    }
  }, []);

  const showConfirm = () => {
    const lng = i18n.language || 'esCHI'
    const tx = (key, opts = {}) => t(key, { lng, ...opts })
    const confirmBase = {
      title: tx('messages.aml.confirmation'),
      okText: tx('messages.aml.modalRequestOpt.confirmModal.ok'),
      cancelText: tx('messages.aml.modalRequestOpt.confirmModal.cancel'),
    }
    switch (type) {
      case ('cronForm'):
        if(period){
          confirm({
            ...confirmBase,
            content: tx('messages.aml.modalRequestOpt.confirm.scheduleSendToPeople', {
              period: tx('messages.aml.onboarding.period.' + period),
            }),
            onOk() {
              handleSendRequest()
            },
            onCancel() {
            },
          });
        }else {
          message.info(tx('messages.aml.modalRequestOpt.selectPeriod'))
        }
      break;
      case "newRequest":
        confirm({
          ...confirmBase,
          content: tx('messages.aml.modalRequestOpt.confirm.sendOnboardingFormToPeople'),
          onOk() {
            handleSendRequest()
          },
          onCancel() {
          },
        });
      break;
      case "brokeRegister":
        confirm({
          ...confirmBase,
          content: tx('messages.aml.modalRequestOpt.confirm.activateBankruptcy'),
          onOk() {
            handleSendRequest()
          },
          onCancel() {
          },
        });
      break;
      case "uboFinder":
        confirm({
          ...confirmBase,
          content: tx('messages.aml.modalRequestOpt.confirm.activateUboInvestigation'),
          onOk() {
            handleSendRequest()
          },
          onCancel() {
          },
        });
      break;
      case "form57":
        confirm({
          ...confirmBase,
          content: tx('messages.aml.confirm.send.formc57'),
          onOk() {
            handleSendRequest()
          },
          onCancel() {
          },
        });
      break;
      case ('cronCdiForm'):
        if(cdiRecipients.length === 0) {
          message.info(tx('messages.aml.modalRequestOpt.noRecipients'))
        }else if (!selectedFormType) {
          message.info(tx('messages.aml.modalRequestOpt.selectFormTypeRequired'))
        }else if(period === 'N'){
          confirm({
            ...confirmBase,
            content: tx('messages.aml.modalRequestOpt.confirm.disablePeriodicCdiForm', {
              formName: tx('messages.aml.type.' + selectedFormType),
            }),
            onOk() {
              handleSendRequest()
            },
            onCancel() {
            },
          });
        }else if(period){
          confirm({
            ...confirmBase,
            content: tx('messages.aml.modalRequestOpt.confirm.scheduleCdiFormToPeople', {
              period: tx('messages.aml.onboarding.period.' + period),
              formName: tx('messages.aml.type.' + selectedFormType),
            }),
            onOk() {
              handleSendRequest()
            },
            onCancel() {
            },
          });
        }else {
          message.info(tx('messages.aml.modalRequestOpt.selectPeriod'))
        }
      break;
      case "newCdiRequest":
        if(cdiRecipients.length === 0) {
          message.info(tx('messages.aml.modalRequestOpt.noRecipients'))
        }else if (!selectedFormType) {
          message.info(tx('messages.aml.modalRequestOpt.selectFormTypeRequired'))
        }else {
          confirm({
            ...confirmBase,
            content: tx('messages.aml.modalRequestOpt.confirm.sendNamedFormToPeople', {
              formName: tx('messages.aml.type.' + selectedFormType),
            }),
            onOk() {
              handleSendRequest()
            },
            onCancel() {
            },
          })
        }
      break;
      default:
      break;
    }
  }

  const copyTable = (tableId) => {
    let elTable = null;
      elTable = document.getElementById(tableId)
  

    let range, sel;
    // Ensure that range and selection are supported by the browsers
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      // unselect any element in the page
      sel.removeAllRanges();
      try {
        range.selectNodeContents(elTable);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(elTable);
        sel.addRange(range);
      }
      document.execCommand('copy');
    }
    sel.removeAllRanges();
    message.success(t('messages.aml.modalRequestOpt.tableCopied'))
  }

  const handleSendRequest = () => {
    setIsLoading(true)
    if (type === 'newRequest') {
      const activeRecipients = (recipients || []).filter(isActiveRecipient)
      if (!isSendAll && activeRecipients.length === 0) {
        setIsLoading(false)
        message.warning(t('messages.aml.modalRequestOpt.noRecipients'))
        return
      }
      sendBdRequestPromise({ recipients: activeRecipients.map((recipient) => recipient.id) }, 'KYC', filterCurrentUser, isSendAll).then(results => {
        setIsLoading(false)
        if(results === 'Solicitud eviada correctamente') {
            message.success(t('messages.aml.modalRequestOpt.requestSentSuccess'))
            handleCancel();
        }else {
            notification.error({
            message: t('messages.aml.error')
          })
        }
      })
    }else if (type === 'newCdiRequest'){
      const activeRecipients = (cdiRecipients || []).filter(isActiveRecipient)
      if (!isSendAll && activeRecipients.length === 0) {
        setIsLoading(false)
        message.warning(t('messages.aml.modalRequestOpt.noRecipients'))
        return
      }
      sendBdRequestPromise({ recipients: activeRecipients.map((recipient) => recipient.id) }, selectedFormType, filterCurrentUser, isSendAll).then(results => {
        setIsLoading(false)
        if(results === 'Solicitud eviada correctamente') {
            message.success(t('messages.aml.modalRequestOpt.requestSentSuccess'))
            handleCancel();
        }else {
            notification.error({
            message: t('messages.aml.error'),
          })
        }
      })
    }else if (type === 'cronForm' || type === 'brokeRegister' || type === 'uboFinder' || type === 'form57' || type === 'cronCdiForm') {
      let rec = type === 'cronCdiForm' ? cdiRecipients : recipients
      const formRelated = type === 'cronForm' || type === 'cronCdiForm' || type === 'form57'
      if (!isSendAll && formRelated) {
        rec = (rec || []).filter(isActiveRecipient)
        if (rec.length === 0) {
          setIsLoading(false)
          message.warning(t('messages.aml.modalRequestOpt.noRecipients'))
          return
        }
      }
      sendBatchAction(type === 'cronCdiForm' ? 'cronForm' : type, type === 'cronForm' ? 'KYC' : selectedFormType, period === 'N' ? null : period, rec.map((recipient) => recipient.id), filterCurrentUser, isSendAll)
    }
  }

  const sendBatchAction = (action, typeForm, period, ids, filters, isSendAll) => {
    sendBatchActionPromise(action, typeForm, period, ids, filters, isSendAll).then(results => {
      setIsLoading(false)
      if(results === 'OK') {
          message.success(t('messages.aml.modalRequestOpt.requestSentSuccess'))
          handleCancel();
      }else {
          notification.error({
            message: t('messages.aml.error'),
            description: t('messages.aml.modalRequestOpt.errorOccurred')
          })
      }
    })
  }

  const validaTypeForm = (type, record) => {
    if(type === 'CDI' && currentUser.modules.includes('CDI-FORM-GD') && currentUser.cliente.modules.includes('CDI-FORM-CDI') && (!record || record.category === 'COLABORADOR' || record.category === 'PROVEEDOR')) {
      return true
    }else if(type === 'REL' && currentUser.modules.includes('CDI-FORM-GREL') && currentUser.cliente.modules.includes('CDI-FORM-REL') && (!record || record.category === 'COLABORADOR')) {
      return true
    }else if(type === 'DIR' && currentUser.modules.includes('CDI-FORM-GDIR') && currentUser.cliente.modules.includes('CDI-FORM-DIR') && (!record || record.category === 'DIRECTOR')) {
      return true
    }else if(type === 'PATR' && currentUser.modules.includes('CDI-FORM-GPATR') && currentUser.cliente.modules.includes('CDI-FORM-PATR') && (!record || record.category === 'CLIENTE')) {
      return true
    }else if(type === 'GIFT' && currentUser.modules.includes('CDI-FORM-GF-G') && currentUser.cliente.modules.includes('CDI-FORM-G') && (!record || record.category === 'COLABORADOR')) {
      return true
    }else if(type === 'TRAVEL' && currentUser.modules.includes('CDI-FORM-GF-T') && currentUser.cliente.modules.includes('CDI-FORM-T') && (!record || record.category === 'COLABORADOR')) {
      return true
    }else if(type === 'FP' && currentUser.modules.includes('CDI-FORM-GF-F') && currentUser.cliente.modules.includes('CDI-FORM-F') && (!record || record.category === 'COLABORADOR')) {
      return true
    }else if(type === 'SOC' && currentUser.modules.includes('CDI-FORM-GF-S') && currentUser.cliente.modules.includes('CDI-FORM-S') && (!record || record.category === 'COLABORADOR')) {
      return true
    }else if(type === 'PEP' && currentUser.modules.includes('FORM-PEP') && currentUser.cliente.modules.includes('FORM-PEP')) {
      return true
    }else if(type === 'ODF' && currentUser.modules.includes('FORM-ODF') && currentUser.cliente.modules.includes('FORM-ODF')) {
      return true
    }
    return false
  }

  const changeSelectedFormType = (value) => {
    setSelectedFormType(value)
    if(!isSendAll){
      let rec = []
      recipients.map(recipient => {
        if(validaTypeForm(value, recipient) && isActiveRecipient(recipient)) {
          rec.push(recipient)
        }
      })
      setCdiRecipients(rec)
    }
  }

  const ubosMatchsColumns = [
    {
      title: t('messages.aml.name'),
      dataIndex: "name"
    },
    {
      title: t('messages.aml.rut'),
      dataIndex: "rut"
    }
  ]

  return (
  isLoading ? 
    <Row>
      <Col span={24} style={{justifyContent: 'center', display: 'flex'}}>
        <Spin size="large" />
      </Col>
    </Row>
  :
    <div className="modal-remind-opt">
      {type === 'newRequest' ?
          <>
            <Row gutter={[0, 64]}>
              <Col>
                {t('messages.aml.modalRequestOpt.newOnboarding.intro')}
              </Col>
            </Row>
            <Row gutter={[0, 48]}>
              <Col>
                <ul>
                  {recipients.map((recipient) => <li>{recipient.name}</li>)}
                </ul>
              </Col>
            </Row>
          </>
        : type === 'cronForm' ?
        <>
          <Row gutter={[0, 24]}>
            <Col span={24}>
              {t('messages.aml.modalRequestOpt.selectedRecords')}
            </Col>
              <Col span={24}>
                <ul>
                  {recipients.map(e => <li>{e.name}</li>)}
                </ul>
              </Col>
              <Divider/>
            <Col>
              {t('messages.aml.modalRequestOpt.onboarding.selectPeriodIntro')}
            </Col>
          </Row>
          <Row gutter={[0, 24]}>
            <Col span={10} push={7}>
              <Select style={{width: '100%'}} onChange={(e) => setPeriod(e)}>
                <Option value="N">{t('messages.aml.onboarding.period.N')}</Option>
                <Option value="MONTHLY">{t('messages.aml.onboarding.period.MONTHLY')}</Option>
                <Option value="QUARTERLY">{t('messages.aml.onboarding.period.QUARTERLY')}</Option>
                <Option value="BIANNUAL">{t('messages.aml.onboarding.period.BIANNUAL')}</Option>
                <Option value="ANNUAL">{t('messages.aml.onboarding.period.ANNUAL')}</Option>
                <Option value="M18">{t('messages.aml.onboarding.period.M18')}</Option>
                <Option value="BIENAL">{t('messages.aml.onboarding.period.BIENAL')}</Option>
              </Select>
            </Col>
          </Row>
          <Row gutter={[0, 24]}>
            <Col span={24}>
              {t('messages.aml.modalRequestOpt.periodicityDisclaimer', { today })}
            </Col>
          </Row>
        </>
        : type === 'brokeRegister' ?
          <>
              <Row gutter={[0, 64]}>
                <Col>
                  {t('messages.aml.modalRequestOpt.bankruptcy.intro')}
                </Col>
              </Row>
              <Row gutter={[0, 48]}>
                <Col>
                  <ul>
                    {recipients.map((recipient) => <li>{recipient.name}</li>)}
                  </ul>
                </Col>
              </Row>
            </>
        : type === 'uboFinder' ?
          <>
            <Row gutter={[0, 64]}>
              <Col>
                {t('messages.aml.modalRequestOpt.ubo.intro')}
              </Col>
            </Row>
            <Row gutter={[0, 48]}>
              <Col>
                <ul>
                  {recipients.map((recipient) => <li>{recipient.name}</li>)}
                </ul>
              </Col>
            </Row>
          </>
        : type === 'form57' ?
          <>
            <Row gutter={[0, 64]}>
              <Col>
                {t('messages.aml.system.c57.information')}
              </Col>
            </Row>
            <Row gutter={[0, 48]}>
              <Col>
                <ul>
                {recipients.map((recipient) => <li>{recipient.name}</li>)}
                </ul>
              </Col>
            </Row>
          </>
        : type === 'newCdiRequest' ?
          <>
            <Row type='flex' justify='center' gutter={[0, 20]}>
              <Col span={24}>{t('messages.aml.modalRequestOpt.cdi.selectDeclaration')}</Col>
              <Col span={24}>
                <Select placeholder={t('messages.aml.modalRequestOpt.cdi.commTypePlaceholder')} onChange={ changeSelectedFormType } style={{width: '100%'}}>
                  {formTypeValidator(currentUser, recipients.length > 1 ? null : recipients[0].category).map(type => {
                    return <Select.Option value={type}>{t('messages.aml.type.'+type)}</Select.Option>
                  })}
                </Select>
              </Col>
            </Row>
            <Row gutter={[0, 25]} style={{marginTop: 20}}>
              <Col span={24}>
                {t('messages.aml.modalRequestOpt.cdi.recipientsIntro')}
              </Col>
              <Col span={24}>
                <ul>
                  {cdiRecipients.map((recipient) => <li>{recipient.name}</li>)}
                </ul>
              </Col>
            </Row>
          </>
        : type === 'beneficiariesMatchs' ?
          <>
            <Row gutter={[0, 25]}>
              <Col span={24}>
                {t('messages.aml.modalRequestOpt.beneficiaries.intro')}
              </Col>
              <Col span={24}>
                <ul>
                  {cdiRecipients.map((recipient) => <li>{recipient.name}</li>)}
                </ul>
              </Col>
            </Row>
            <Divider>
              {t('messages.aml.modalRequestOpt.beneficiaries.results')}
            </Divider>
            <Row>
              <Col span={24}>
                {isUbosMatchesLoading ?
                    <div style={{textAlign:"center"}}>
                      <Spin tip={t('messages.aml.modalRequestOpt.beneficiaries.loading')}
                        indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
                      />
                    </div>
                  : 
                    <Row>
                   
                      <div style={{textAlign:"center"}}>
                        { findUbosMatches.length > 0 ?
                          <Table columns={ubosMatchsColumns} dataSource={findUbosMatches} id='beneficiariesMatchsTableInModal' pagination={false}/>
                        :
                          <h3>
                            {t('messages.aml.modalRequestOpt.beneficiaries.noMatches')}
                          </h3>
                        }
                      </div>
                    </Row>
                }
              </Col>
            </Row>
          </>
        : type === 'cronCdiForm' ?
          <>
            <Row>
              <Col span={10}>{t('messages.aml.modalRequestOpt.cdi.selectDeclaration')}</Col>
              <Col span={14}>
                <Select placeholder={t('messages.aml.modalRequestOpt.cdi.commTypePlaceholderLong')} onChange={ changeSelectedFormType } style={{width: '100%'}}>
                  {formTypeValidator(currentUser, recipients.length > 1 ? null : recipients[0].category).map(type => {
                    return <Select.Option value={type}>{t('messages.aml.type.'+type)}</Select.Option>
                  })}
                </Select>
              </Col>
            </Row>
            <Row gutter={[0, 24]}>
              <Col span={24}>
                {t('messages.aml.modalRequestOpt.selectedRecords')}
              </Col>
              <Col span={24}>
                <ul>
                  {cdiRecipients.map(e => <li>{e.name}</li>)}
                </ul>
              </Col>
              <Divider/>
              <Col span={24}>
                {t('messages.aml.modalRequestOpt.cdiCron.selectPeriodIntroGeneric')}
              </Col>
            </Row>
            <Row gutter={[0, 24]}>
              <Col span={10} push={7}>
                <Select
                  style={{width: '100%'}}
                  placeholder={t('messages.aml.modalRequestOpt.cdiCron.selectPeriodPlaceholder')}
                  onChange={(e) => setPeriod(e)}
                >
                  <Option value="N">{t('messages.aml.onboarding.period.N')}</Option>
                  <Option value="MONTHLY">{t('messages.aml.onboarding.period.MONTHLY')}</Option>
                  <Option value="QUARTERLY">{t('messages.aml.onboarding.period.QUARTERLY')}</Option>
                  <Option value="BIANNUAL">{t('messages.aml.onboarding.period.BIANNUAL')}</Option>
                  <Option value="ANNUAL">{t('messages.aml.onboarding.period.ANNUAL')}</Option>
                  <Option value="M18">{t('messages.aml.onboarding.period.M18')}</Option>
                  <Option value="BIENAL">{t('messages.aml.onboarding.period.BIENAL')}</Option>
                </Select>
              </Col>
            </Row>
            <Row gutter={[0, 24]}>
              <Col span={24}>
                {t('messages.aml.modalRequestOpt.periodicityDisclaimer', { today })}
              </Col>
            </Row>
          </>
        : null 
      }
      { type !== 'beneficiariesMatchs' ?
          <Row>
            <Divider/>
            { isSendAll ? 
              <span style={{ whiteSpace: 'pre-line' }}>
                {t('messages.aml.modalRequestOpt.sendAllWarningMass', { count: formatCount(totalCurrentUser) })}
              </span> : "" }        
            <Button style={{float: 'right'}} onClick={showConfirm} disabled={(type === 'newCdiRequest' || type === 'cronCdiForm') && selectedFormType === null}>
              {t('messages.aml.accept')}
            </Button>
          </Row>
        : findUbosMatches.length > 0 &&
          <Row type='flex' justify='center'>
            <Button style={{textAlign: 'center', marginTop: 20}} type="primary" onClick={() => copyTable('beneficiariesMatchsTableInModal')} disabled={(type === 'newCdiRequest' || type === 'cronCdiForm') && selectedFormType === null}>
              {t('messages.aml.copyTable')}
            </Button>
          </Row>
      }
    </div>
  )
}

export default ModalRequestOpt
